import React, { useState } from 'react'
import { Routes, Route, useLocation } from 'react-router-dom'

import LandingPage from './components/LandingPage/LandingPage'
import AuthCallback from './components/Auth/AuthCallback'
import Header from './components/Layout/Header'
import DrawingCanvas from './components/Canvas/DrawingCanvas'
import ToolPanel from './components/Tools/ToolPanel'
import LayerPanel from './components/Layers/LayerPanel'
import { DrawingProvider, useDrawing } from './context/DrawingContext'
import SignUpForm from './components/Auth/SignUpForm'
import Dashboard from './components/Dashboard/Dashboard'
import ResultPage from './components/Result/ResultPage'
import ProgramResultPage from './components/Result/ProgramResultPage'
import styles from './App.module.css'
import Gallery from './components/Gallery/MyGallery'
import Help from './components/Help/HelpCenter'
import Profile from './components/Profile/MyProfile'
import Community from './components/Community/CommunityPage'
import DiaryPage from './components/Diary/DiaryPage'

// 드로잉 페이지 내부 컴포넌트 (Context 사용)
function DrawingPage() {
  const { state } = useDrawing()
  const showPanels = state.currentMode === 'draw'

  return (
    <div className={styles.app}>
      <Header />
      <div className={styles.mainContent}>
        {showPanels && (
          <aside className={styles.leftPanel}>
            <ToolPanel />
          </aside>
        )}

        <main className={styles.canvasContainer}>
          <DrawingCanvas />
        </main>

        {showPanels && (
          <aside className={styles.rightPanel}>
            <LayerPanel />
          </aside>
        )}
      </div>
    </div>
  )
}

function App() {
  const location = useLocation()
  return(
    <div key={location.pathname} className={styles.routeFade}>
    <Routes>
      <Route path="/" element={<LandingPage />} />
      <Route path="/auth/callback/*" element={<AuthCallback />} />
      <Route path="/signup" element={<SignUpForm />} /> 
      <Route path="/dashboard" element={<Dashboard />} /> 
      <Route path="/result" element={<ResultPage/>} /> 
      <Route path="/drawing-analysis/:drawingAnalysisId" element={<ResultPage />} />
      <Route path="/programs/:therapyProgramId/result" element={<ProgramResultPage />} />
      <Route path="/gallery" element={<Gallery/>} />
      <Route path="/help" element={<Help/>} />
      <Route path="/profile" element={<Profile/>} />
      <Route path="/community" element={<Community/>} />
      <Route path="/diary" element={<DiaryPage />} />
      <Route path="/diary/write" element={<DiaryPage />} />
      <Route path="/diary/detail/:diaryId" element={<DiaryPage />} />
      <Route path="/diary/result" element={<DiaryPage />} />
      
      {/* 드로잉 페이지 (Provider 포함) */}
      <Route
        path="/drawing"
        element={
          <DrawingProvider>
            <DrawingPage />
          </DrawingProvider>
        }
      />
    </Routes>
    </div>
  )
}

export default App